import { render, staticRenderFns } from "./Reviewslist.vue?vue&type=template&id=1cb97e1b&scoped=true"
import script from "./Reviewslist.vue?vue&type=script&lang=js"
export * from "./Reviewslist.vue?vue&type=script&lang=js"
import style0 from "./Reviewslist.vue?vue&type=style&index=0&id=1cb97e1b&prod&lang=css"
import style1 from "./Reviewslist.vue?vue&type=style&index=1&id=1cb97e1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb97e1b",
  null
  
)

export default component.exports